import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  return (
    <main id="main-content" className="returns-page">
      <header className="returns-page__header" aria-labelledby="returns-title">
        <p className="returns-page__eyebrow">Information</p>
        <h1 id="returns-title">Returns</h1>
        <p>
          We hope you will live happily with your purchase. If it is not right,
          eligible items can be returned by contacting us within 14 days of delivery.
        </p>
      </header>

      <aside className="returns-page__summary" aria-label="Return window summary">
        <strong>14</strong>
        <span>days from delivery to tell us you would like to return an item</span>
      </aside>

      <div className="returns-page__body">
        <section aria-labelledby="returns-start">
          <h2 id="returns-start">1. Start a return</h2>
          <p>
            Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
            {" "}within 14 days of receiving your order. Include your order details,
            the item you wish to return and a brief reason so we can send the
            correct return instructions.
          </p>
          <p>
            Please do not send a parcel before contacting us. Returns should be
            posted promptly after we acknowledge your request.
          </p>
        </section>

        <section aria-labelledby="returns-condition">
          <h2 id="returns-condition">2. Condition of returned work</h2>
          <p>
            Items must be unused, in saleable condition and returned with their
            original packaging, labels and any certificates. Pack fragile work
            carefully and use a tracked, insured service appropriate to its value.
          </p>
          <p>
            Return postage is your responsibility unless the item arrived faulty,
            damaged or was sent in error. Original delivery charges and import
            duties are not refundable except where required by law.
          </p>
        </section>

        <section aria-labelledby="returns-exclusions">
          <h2 id="returns-exclusions">3. Items that cannot be returned</h2>
          <p>
            Bespoke or personalised pieces, gift cards, perishable goods and
            sealed hygiene-sensitive items that have been opened cannot usually
            be returned. This does not affect your rights where an item is faulty
            or not as described.
          </p>
        </section>

        <section aria-labelledby="returns-damage">
          <h2 id="returns-damage">4. Damage in transit</h2>
          <p>
            Check your parcel when it arrives. If something is damaged, contact
            us within four days and keep the object and all packaging. Photographs
            of the parcel and damage will help us resolve the issue quickly.
          </p>
        </section>

        <section aria-labelledby="returns-refund">
          <h2 id="returns-refund">5. Refunds</h2>
          <p>
            We will inspect the return and email you when it has been accepted.
            Approved refunds are sent to the original payment method, normally
            within 10 working days. Your bank may take additional time to show it.
          </p>
        </section>

        <section aria-labelledby="returns-more">
          <h2 id="returns-more">6. More information</h2>
          <p>
            Read our <Link to="/shipping">shipping information</Link> and{" "}
            <Link to="/terms">terms of service</Link>, or visit the{" "}
            <Link to="/contact">contact page</Link> if you need help with an order.
          </p>
        </section>
      </div>
    </main>
  );
}

export default Returns;
